import { JRCLoader } from 'components/JRCLoader/JRCLoader';

import { useImageLoader } from 'hooks/UseImageLoader';
import * as React from 'react';
import { fileAvatar } from 'utils/utils.files';
import styled from 'styled-components';
import { JRCFileProps } from './types';

export const BackgroundImage = styled.div<{ uri: string }>`
    border-radius: 8px;
    width: 100%;
    height: 100%;
    background-position: top center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('${(props) => props.uri}');
`;

export const ImageWrapper = styled.div<{ maxWidth: number | undefined; maxHeight: number | undefined }>`
    flex: 1;
    display: flex;
    justify-content: center;
    height: 100%;
    ${(props) => props.maxWidth !== undefined && `max-width: ${props.maxWidth}px;`}
    ${(props) => props.maxHeight !== undefined && `max-height: ${props.maxHeight}px;`}
    margin: auto;
    position: relative;
`;

export const ImageImg = styled.img``;

export const LoaderWrapper = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const JRCFileImage = ({ uri, size = undefined, mimetype = 'image/png', display }: JRCFileProps) => {
    const file = fileAvatar(mimetype);
    return display === 'avatar' ? (
        <BackgroundImageLoader uri={uri ?? file.path} />
    ) : (
        <Img uri={uri ?? file.path} size={size} />
    );
};

export const BackgroundImageLoader = ({ uri }: { uri: string }) => {
    const { loading, width, height } = useImageLoader(uri);
    if (loading || width === 0 || height === 0) {
        return <JRCLoader size={'s'} />;
    }

    return <BackgroundImage uri={uri} />;
};

export const Img = ({ uri, size }: { uri: string; size: number | undefined }) => {
    const { loading, width, height } = useImageLoader(uri, size);
    return (
        <ImageWrapper maxWidth={width === 0 ? undefined : width} maxHeight={height === 0 ? undefined : height}>
            <ImageImg src={uri} />
            {loading && (
                <LoaderWrapper>
                    <JRCLoader size={'l'} />
                </LoaderWrapper>
            )}
        </ImageWrapper>
    );
};
